import { OrderTemplate } from "@/types";

import { ReactNode } from "react";

export enum ORDER_STEP {
  CUSTOMER_AND_PACKAGE,
  BOOKING,
  PROGRESS,
  PAYMENT,
  CONTENT_SELECTION,
  AWAITING_CONFIRMATION,
}

export interface CreateOrderMethods {
  onCreateOrder: () => void;
}

export interface OrderCreateProps extends CreateOrderMethods {
  activeStep: ORDER_STEP;
  children: ReactNode;
  extraText?: string;
  isAdmin: boolean;
  isReadOnly?: boolean;
  selectedOrder: OrderTemplate | null;
}

export interface StyledOrderProps {
  showFooter: boolean;
}